import { render, staticRenderFns } from "./NavSave.vue?vue&type=template&id=83c75f3e&"
import script from "./NavSave.vue?vue&type=script&lang=js&"
export * from "./NavSave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports